import { observer } from 'mobx-react-lite';
import DigitalHumanStore from '@/stores/digital-human-store';

interface CourseCardsOverlayProps {
  store: DigitalHumanStore;
}

export const CourseCardsOverlay = observer(({ store }: CourseCardsOverlayProps) => {
  if (!store.courseCardsVisible || store.courseCards.length === 0) {
    return null;
  }

  return (
    <div className={`pointer-events-none absolute inset-x-0 bottom-48 z-[70] flex flex-row flex-wrap justify-center gap-4 px-8 transition-opacity duration-500 ${store.courseCardsFading ? 'opacity-0' : 'opacity-100'}`}>
      {store.courseCards.map((card, index) => {
        const isSelected = store.selectedCourseId === card.courseId;
        const isOther = store.selectedCourseId != null && !isSelected;

        return (
          <div
            key={`${card.courseId}-${index}`}
            className={`flex w-80 flex-col justify-center rounded-2xl border px-6 py-5 text-white shadow-xl backdrop-blur-md transition-all duration-500 ${
              isSelected
                ? 'animate-card-selected border-emerald-400/60 bg-emerald-500/20'
                : isOther
                  ? 'border-white/10 bg-white/5 opacity-40'
                  : 'animate-slide-up border-white/20 bg-white/10'
            }`}
            style={!isSelected ? { animationDelay: `${index * 0.08}s` } : undefined}
          >
            <div className="flex items-center justify-start gap-3">
              <div
                className={`h-0.5 w-10 flex-shrink-0 rounded-full transition-colors duration-500 ${
                  isSelected ? 'bg-emerald-300' : 'bg-violet-400'
                }`}
              />
              <h3 className="text-base font-semibold leading-snug">{card.title}</h3>

              {isSelected && (
                <svg
                  className="h-6 w-6 flex-shrink-0 text-emerald-300"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
});
